import { displayAlert } from '../../main/utils';
import {
  AssertedPublicKeyCredential,
  AuthCredential,
  transformCredentials,
  transformPublicKey,
} from '../../main/webauthn';

const basePath = '/webauthn';
const form = document.querySelector<HTMLFormElement>('#sign-in-username-form');

async function run() {
  // in a test env that lacks TLS, this should be a no-op. Otherwise you can
  // get a really confusing message about "operation failed" when run under
  // firefox.
  if (window.location.protocol !== 'https:') {
    return;
  }
  if (
    typeof window.PublicKeyCredential === 'undefined' ||
    typeof window.PublicKeyCredential.isConditionalMediationAvailable !==
      'function'
  ) {
    return;
  }

  const available = await PublicKeyCredential.isConditionalMediationAvailable();

  if (!available) {
    return;
  }

  try {
    const authOptions = await getOptions();
    const pk = transformPublicKey(authOptions.publicKey);

    const webAuthnResponse = (await navigator.credentials.get({
      mediation: 'conditional',
      publicKey: {
        ...pk,
        userVerification: 'preferred',
      },
    })) as AssertedPublicKeyCredential | null;
    if (!webAuthnResponse) {
      throw Error('navigator.credentials.get did not return credentials');
    }

    const cred = transformCredentials(webAuthnResponse);

    await finishAuth(cred);

    redirect();
  } catch (err) {
    const alert = displayAlert('Authentication failed.', 'danger');
    const link = document.createElement('a');

    link.textContent = ' Try again.';
    link.href = '#';
    link.onclick = async (e) => {
      e.preventDefault();
      alert.hidden = true;
      await run();
    };
    alert.appendChild(link);

    console.error(err);
  }
}

async function getOptions() {
  const res = await fetch(`${basePath}/authenticate/discoverable/start`);

  if (!res.ok) {
    throw res;
  }

  return res.json();
}

async function finishAuth(assertion: AuthCredential) {
  const csrfToken = form?.elements.namedItem('csrf_token') as HTMLInputElement;
  const res = await fetch(`${basePath}/authenticate/discoverable/finish`, {
    body: JSON.stringify(assertion),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=UTF-8',
      'X-CSRF-Token': csrfToken.value,
    },
    method: 'POST',
  });
  if (!res.ok) {
    throw res;
  }

  return res;
}

function redirect() {
  const redirectTo = form?.elements.namedItem(
    'redirect_to',
  ) as HTMLInputElement;

  const url = new URL(redirectTo.value, window.location.href);

  window.location.href = url.toString();
}

await run();
